export const Section4 = ()=>{

  const images = [
    "https://9wicket.pro/static/media/fvo-1.84a8526ad5ca8e341203.jpg",
    "https://9wicket.pro/static/media/fvo-2.b20042efaffed8b698c8.png",
    "https://9wicket.pro/static/media/fvo-3.b29e0fa3bd11ce72e3b8.jpg",
  ]

  const casinoGames = [
    "https://9wicket.pro/static/media/fg-1.587e02853648d0e89b3c.jpg",
    "https://9wicket.pro/static/media/fg-2.86fc0fae819d2c525c41.jpg",
    "https://9wicket.pro/static/media/fg-3.102508f76f6f9b3f7106.jpg",
    "https://9wicket.pro/static/media/fg-4.c18d3d3dbf20cd362bc7.jpg",
    "https://9wicket.pro/static/media/fg-5.94fcc30e36c6fed1272b.jpg",
    "https://9wicket.pro/static/media/fg-6.67d89821fe41a919fb06.jpg",
    "https://9wicket.pro/static/media/fg-7.ec72e5826eab4dba78a5.jpg",
    "https://9wicket.pro/static/media/fg-8.fd83e0bce33552660c0b.jpg",
    "https://9wicket.pro/static/media/fg-9.90ce980fffd51d5e20fa.png",
  ]

  return (
    <section className=" bg-bg-3 mt-3 p-2">
      <div className=" flex gap-1 mt-2">
        <div className=" bg-gray-400 w-[4px] h-[20px] inline-block "></div>
        <h3 className=" text-white font-bold capitalize">Upcoming Events</h3>
      </div>

      <div className=" flex gap-4 mt-2 overflow-x-auto scroll-smooth">
        {images.map((image, index) => (
          <div
            key={index}
            className=" border-2 border-gray-400 overflow-hidden rounded-lg flex-shrink-0"
          >
            <img
              src={image}
              alt={`Upcoming event ${index}`}
              className="rounded-lg hover:scale-125 transition-all duration-300"
              width={300}
            />
          </div>
        ))}
      </div>
      <div className=" flex gap-1 mt-4">
        <div className=" bg-gray-400 w-[4px] h-[20px] inline-block "></div>
        <h3 className=" text-white font-bold capitalize">Hot Casino Games</h3>
      </div>

      <div className=" flex gap-2 mt-2 overflow-x-auto scroll-smooth">
        {casinoGames.map((image) => (
          <div className=" overflow-hidden flex-shrink-0 ">
            <img
              src={image}
              width={200}
              alt=""
              className=" hover:scale-125 transition-all duration-300"
            />
          </div>
        ))}
      </div>
    </section>
  );
}